import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import api from "@/lib/api";
import { useMember } from "@/context/MemberContext";

export default function VerifyMember() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useMember();
  const [state, setState] = useState("Verifying your sign-in link…");
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const token = params.get("token");
    window.history.replaceState({}, "", "/member/verify");
    if (!token) { setState("This sign-in link is missing its token."); return; }
    api.post("/member/consume", { token })
      .then(async () => {
        await refresh();
        setOk(true);
        setState("You're signed in. Enjoy the exclusive content.");
        setTimeout(() => navigate("/healing", { replace: true }), 1400);
      })
      .catch((e) => setState(e.response?.data?.detail || "This sign-in link is invalid or has expired."));
  }, [params, navigate, refresh]);

  return (
    <PublicLayout>
      <div className="pt-44 pb-40 px-6 text-center" data-testid="member-verify">
        <div className="gv-label text-[#C5A059]">Members</div>
        <p className="mt-6 font-serif text-3xl text-[#1A1F24]">{state}</p>
        {!ok && (
          <Link to="/healing" className="mt-8 inline-block gv-link text-sm tracking-[0.2em] uppercase text-[#C5A059]">
            Back to the Space for Healing Together
          </Link>
        )}
      </div>
    </PublicLayout>
  );
}
